import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { verifyAffiliateCode } from "../hooks/useAffiliateCode";
import { PRICE_PLAN_URL } from "../config/siteUrls";

const PricePlanAffiliate = () => {
  const { affiliateCode } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const normalizedCode = affiliateCode?.trim()?.toUpperCase();
    const query = new URLSearchParams(searchParams);
    const redirect = () => {
      const queryString = query.toString();
      window.location.replace(queryString ? `${PRICE_PLAN_URL}?${queryString}` : PRICE_PLAN_URL);
    };

    if (!normalizedCode || normalizedCode.length <= 4) {
      redirect();
      return;
    }

    const verifyAndRedirect = async () => {
      localStorage.removeItem("deliva_affiliate_code");
      const result = await verifyAffiliateCode(normalizedCode);
      if (result.isValid) {
        localStorage.setItem("deliva_affiliate_code", normalizedCode);
        query.set("ref", normalizedCode);
      }
      redirect();
    };

    verifyAndRedirect();
  }, [affiliateCode]);

  return null;
};

export default PricePlanAffiliate;
